// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"249":"08c2b9d3","979":"a79429ac"}[chunkId] + ".js";
};